import { updateURLSearchParams, getPosts } from './helpers'

document.addEventListener('DOMContentLoaded', () => {
  const filtersFormEl = document.querySelector('.filters__form')
  const filterButtons = document.querySelectorAll('.filters__form input[type=radio]')
  const urlParams = new URLSearchParams(window.location.search)

  const resetPaged = () => {
    const url = new URL(window.location)
    url.searchParams.delete('paged')
    window.history.pushState(null, '', url)
  }

  const updatePaginationLinks = () => {
    document.querySelectorAll('.pagination a').forEach((link) => {
      link.addEventListener('click', async (event) => {
        event.preventDefault()
        const url = new URL(link.href)
        const paged = url.searchParams.get('paged')
        const currentUrl = new URL(window.location)
        currentUrl.searchParams.set('paged', paged)
        window.history.pushState(null, '', currentUrl)
        await getPosts()
        updatePaginationLinks()
      })
    })
  }

  filterButtons?.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        filtersFormEl.requestSubmit()
      }
    })
    if (radio.value === urlParams.get(radio.name)) radio.checked = true
    if (!urlParams.get(radio.name) && !radio.value) radio.checked = true
  })

  filtersFormEl?.addEventListener('submit', async (e) => {
    e.preventDefault()
    updateURLSearchParams(e.target)
    resetPaged()
    await getPosts()
    updatePaginationLinks()
  })

  updatePaginationLinks()
})
